export default {
  // New Getter
  getTreeGridApi: (state) => state.ofcTree.gridOptions,
  getUserInfo: (state) => state.userInfo,
  getUserId: (state) => state.userInfo.id,
  getUserName: (state) => state.userInfo.name,
  getUserAuth: (state) => state.userInfo.auth,
  // Old Getter
  getIsAuth: (state) => state.isAuth,
  getCenterBus: (state) => state.centerBus,
  getSidebar: (state) => state.sidebar,
  getWebSocket: (state) => state.webSocket,
  getPageMoveParams: (state) => state.pageMoveParams,
  getCurrentPath: (state) => state.routerInfo.curPath,
  getUserPageAuth: (state) => state.userPageAuth,
  getAlertOptions: (state) => state.alertOptions,
  getConfirmOptions: (state) => state.confirmOptions,
  getLoaderOn: (state) => state.loaderOn,
  getWindowHeight: (state) => state.windowsize.height,
  getWindowWidth: (state) => state.windowsize.width,
  // 사용자 편의를 위한 Getter
  getSelectedDataProjectid: (state) => state.selectedData.projectid,
  getSelectedDataStid: (state) => state.selectedData.stid,
  getSelectedDataStartDate: (state) => state.selectedData.startDate,
  getSelectedDataEndDate: (state) => state.selectedData.endDate,
};



// WEBPACK FOOTER //
// ./src/vuex/getters.js